import { useEffect, useState } from 'react';

/**
 * Detects the rough graphics/compute capability of the current device.
 *
 * Returns one of 'low' | 'mid' | 'high'. Used to gate expensive visual
 * features (Three.js DPR, Sparkles counts, particle systems).
 *
 * Heuristic:
 *  - hardwareConcurrency (CPU threads)
 *  - deviceMemory (GB)
 *  - Coarse pointer / mobile UA (touch-first devices)
 *  - prefers-reduced-motion (always downgrades to 'low')
 */
export default function useDevicePower() {
  const [tier, setTier] = useState('mid');

  useEffect(() => {
    if (typeof navigator === 'undefined') return;
    const cpu = navigator.hardwareConcurrency || 6;
    const mem = navigator.deviceMemory || 6;
    const isMobile = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent || '');
    const coarse = typeof window.matchMedia === 'function'
      && window.matchMedia('(pointer: coarse)').matches;
    const reduced = typeof window.matchMedia === 'function'
      && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced) { setTier('low'); return; }
    if (isMobile || coarse || cpu <= 4 || mem <= 4) { setTier('low'); return; }
    if (cpu >= 8 && mem >= 8) { setTier('high'); return; }
    setTier('mid');
  }, []);

  return tier;
}
